import { call, put, takeEvery } from 'redux-saga/effects';
import {
	fetchFieldMetadataAction,
	fetchFieldMetadataResolved,
	fetchFieldMetadataRejected,
} from '@Actions/rehab.actions';
import { fetchFieldMetadata } from '@Services/rehab.services';
import { EventType, TaskType, ConditionScore } from '@Types/rehab.types';

export function* fetchFieldMetadataSaga(action: ReturnType<typeof fetchFieldMetadataAction>) {
	try {
		const { type, systemType, assetType, inspectionStandard } = action.payload;

		const result: EventType[] | TaskType[] | ConditionScore[] = yield call(
			fetchFieldMetadata,
			type, // 'events', 'tasks', 'condition'
			systemType,
			assetType,
			inspectionStandard,
		);
		yield put(fetchFieldMetadataResolved({ type, data: result }));
	} catch (error) {
		const message = error instanceof Error ? error.message : 'Unknown error';
		yield put(
			fetchFieldMetadataRejected({
				type: action.payload.type,
				error: message,
			}),
		);
	}
}

export function* watchFetchFieldMetadata() {
	yield takeEvery(fetchFieldMetadataAction, fetchFieldMetadataSaga);
}

const sagaArray = [watchFetchFieldMetadata()];

export default sagaArray;
